"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var change_case_1 = require("change-case");

exports.camelCase = change_case_1.camelCase;
exports.capitalCase = change_case_1.capitalCase;
exports.titleCase = change_case_1.capitalCase;
exports.pascalCase = change_case_1.pascalCase;
exports.paramCase = change_case_1.paramCase;
exports.snakeCase = change_case_1.snakeCase;

var upper_case_1 = require("upper-case");

exports.upperCase = upper_case_1.upperCase;

var lower_case_1 = require("lower-case");

exports.lowerCase = lower_case_1.lowerCase;